<template>
  <v-container>
    <h1>Posts / Custom Post Types</h1>
    <h2>
      {{
        $route.params.type ||
          "posts/:type Dynamic route varaiable example: posts/my-custom will output my-custom"
      }}
    </h2>
    <user-test />
  </v-container>
</template>

<script>
export default {
  name: "Posts",
  route: {
    path: "/posts/:type?",
    name: "Posts",
  },
};
</script>

<style></style>
